import type { HelpTopic } from './types';

/** Shown when a screen has no guide of its own, and listed first in "All guides". */
export const generalHelp: HelpTopic = {
  path: '/__general',
  title: 'Using this panel',
  summary: 'How the menu, the Help button and your role work together.',
  sections: [
    {
      title: 'The menu',
      bullets: [
        'The menu on the left shows only the screens your role may open. Click a main menu (for example HR or Accounts) to open its sub-menus.',
        'If a screen or a button you need is missing, your role does not have it. Ask the admin to add it on Administration → Roles & Menu Access.',
        'The line at the top of every page (the breadcrumb) shows where you are. Click a part of it to go back.',
      ],
    },
    {
      title: 'Help on every screen',
      bullets: [
        'Click Help (top right of the page) or press F1 to read the guide for the screen you are on.',
        'Use the search box in the guide to find help for any other screen.',
        'Fields marked "required" in the guide must be filled before the screen will save.',
      ],
    },
    {
      title: 'Saving and errors',
      bullets: [
        'After you save, a green message confirms it. A red message tells you what to correct; nothing was saved.',
        'If you see "changed by someone else", another person saved the same record first. Reload the page and enter your change again.',
        'Your login closes itself after a long time without activity. Save your work before leaving the computer.',
      ],
    },
  ],
};
